// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-datepicker[data-v-79242485] i:after{background-color:transparent !important}\n", ""]);
// Exports
module.exports = exports;
